import {
	buyByColorDrawerTitleCloseSx,
	buyByColorDrawerTitleDividerSx,
	buyByColorDrawerTitleSx,
} from '@/components/blocks/ProductDetails/styles/buyByColor';
import { Close } from '@mui/icons-material';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { FC } from 'react';

interface DrawerTitleProps {
	handleCloseDrawer: () => void;
	title: string;
	closeButtonAlign: 'left' | 'right';
}

export const DrawerTitle: FC<DrawerTitleProps> = ({
	handleCloseDrawer,
	title,
	closeButtonAlign = 'left',
}) => (
	<Box>
		<Box sx={buyByColorDrawerTitleSx}>
			<IconButton
				aria-label="close drawer"
				onClick={handleCloseDrawer}
				sx={buyByColorDrawerTitleCloseSx({ closeButtonAlign })}
			>
				<Close />
			</IconButton>
			<Typography variant="body1" align="center">
				{title}
			</Typography>
		</Box>
		<Divider sx={buyByColorDrawerTitleDividerSx} />
	</Box>
);
